import VeilederLutDto from '../Models/VeilederLutDto';
import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';

const afrika = 'a1-afrika';
const asia = 'a2-asia';
const europa = 'a3-europa';
const nordMellomAmerika = 'a4-nordMellomAmerika';
const oseania = 'a5-oseania';
const sorAmerika = 'a6-sorAmerika';

const aValg: RadioButtonValgModel<VeilederLutDto>[] = [
    { id: 'AFR', value: afrika, tekst: 'valgAfrika' },
    { id: 'ASI', value: asia, tekst: 'valgAsia' },
    { id: 'EUR', value: europa, tekst: 'valgEuropa' },
    { id: 'NMA', value: nordMellomAmerika, tekst: 'valgNordMellomAmerika' },
    { id: 'OSE', value: oseania, tekst: 'valgOseania' },
    { id: 'SAM', value: sorAmerika, tekst: 'valgSorAmerika' }, 
];

export default {
    a1_afrika: afrika,
    a2_asia: asia,
    a3_europa: europa,
    a4_nordMellomAmerika: nordMellomAmerika,
    a5_oseania: oseania,
    a6_sorAmerika: sorAmerika,
    aValg,
};